export function useAuthorisationChecker() {
    const { payload } = storeToRefs(useAuthStore());
    const config = useRuntimeConfig();

    function isAuthorised({
        dev,
        feature,
        permission,
    }: {
        dev?: boolean;
        feature?: string;
        permission?: string;
    }) {
        if (dev && config.public.appEnv !== "local") return false;

        const requiresPermission = !!permission;
        const requiresFeature = !!feature;

        if (!requiresPermission && !requiresFeature) return true;

        if (!payload.value) return false;

        if (
            requiresPermission &&
            !payload.value.permissions.includes(permission)
        ) {
            return false;
        }

        if (requiresFeature && !payload.value.features[feature]) {
            return false;
        }

        return true;
    }

    return { isAuthorised };
}
